export * from './Address'
export * from './BillingInvoice'
export * from './BillingInvoiceItem'
export * from './BillingPlan'
export * from './BillingRun'
export * from './BillingSubscription'
export * from './BillingSupplierConfig'
export * from './Calendar'
export * from './Contact'
export * from './Consultation'
export * from './ConsultationType'
export * from './ConsultationPrice'
export * from './Country'
export * from './Dossier'
export * from './DossierItem'
export * from './Document'
export * from './EmailCommunication'
export * from './Employment'
export * from './Event'
export * from './EventLocationTag'
export * from './HealthFund'
export * from './Invoice'
export * from './InvoiceConfiguration'
export * from './InvoiceItem'
export * from './Location'
export * from './Office'
export * from './Organisation'
export * from './User'
export * from './SelectableCalendar'
export * from './CommunicationRecipient'
export * from './ConsultationReminder'
export * from './EmailTemplate'
export * from './EventConsultationTypeTag'
export * from './EventDossierTag'
export * from './GenerateConsultationError'
export * from './MatchProposal'
export * from './MatchReview'
export * from './Notification'
export * from './Receipt'
export * from './Relationship'
export * from './RemoveConsultationError'
export * from './Team'
export * from './Template'
export * from './Todo'

import { ORM } from 'redux-orm'
import Address from './Address'
import BillingInvoice from './BillingInvoice'
import BillingInvoiceItem from './BillingInvoiceItem'
import BillingPlan from './BillingPlan'
import BillingRun from './BillingRun'
import BillingSubscription from './BillingSubscription'
import BillingSupplierConfig from './BillingSupplierConfig'
import Calendar from './Calendar'
import Consultation from './Consultation'
import ConsultationPrice from './ConsultationPrice'
import ConsultationReminder from './ConsultationReminder'
import ConsultationType from './ConsultationType'
import Contact from './Contact'
import Country from './Country'
import Document from "./Document";
import Dossier from './Dossier'
import DossierItem from './DossierItem'
import EmailCommunication from './EmailCommunication'
import EmailTemplate from './EmailTemplate'
import Employment from './Employment'
import Event from './Event'
import EventConsultationTypeTag from './EventConsultationTypeTag'
import EventDossierTag from './EventDossierTag'
import EventLocationTag from './EventLocationTag'
import GenerateConsultationError from './GenerateConsultationError'
import MatchProposal from './MatchProposal'
import MatchReview from './MatchReview'
import HealthFund from './HealthFund'
import Invoice from './Invoice'
import InvoiceConfiguration from "./InvoiceConfiguration"
import InvoiceItem from './InvoiceItem'
import Location from './Location'
import Notification from './Notification'
import Office from './Office'
import Organisation from './Organisation'
import Receipt from './Receipt'
import Relationship from "./Relationship";
import CommunicationRecipient from "./CommunicationRecipient";
import RemoveConsultationError from './RemoveConsultationError'
import SelectableCalendar from './SelectableCalendar'
import Team from "./Team";
import Template from "./Template";
import Todo from './Todo'
import User from './User'

const orm = new ORM()
orm.register(Address, Calendar, Contact, ConsultationType, ConsultationPrice, Country, Location, Dossier,
             DossierItem, Document, HealthFund, EmailCommunication, Employment, Office, Organisation, User, Invoice,
             InvoiceConfiguration, InvoiceItem, SelectableCalendar, Consultation, Event, ConsultationReminder,
             EmailTemplate, EventConsultationTypeTag, EventDossierTag, EventLocationTag, GenerateConsultationError, MatchProposal, MatchReview, Notification,
             Receipt, Relationship, CommunicationRecipient, RemoveConsultationError, Team, Template, Todo,
             BillingPlan, BillingSubscription, BillingRun, BillingInvoice, BillingInvoiceItem, BillingSupplierConfig)

export default orm;
